module.exports = __webpack_public_path__ + "img/bottom_icon2.add7ffe9_add7ffe9e0523a92f9f49e56d53bcb12.add7ffe9.png";